

























import {
	computed,
	defineComponent,
	PropType,
	Ref,
} from '@vue/composition-api';
import { DEFAULT_RANGE } from '@front-app/router/util/groupDataQuery';
import { GroupDataRange } from '@front-app/services/GroupsApi/GroupDataModel';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import RadioList from '@front-app/components/inputs/RadioList.vue';
import RadioListButton from '@front-app/components/inputs/RadioListButton.vue';
import PremiumTooltip from './PremiumTooltip.vue';

const DATA_RANGE_LABELS: Record<GroupDataRange, string> = {
	[GroupDataRange.LAST_30_DAYS]: 'data-range.last-30-days',
	[GroupDataRange.LAST_90_DAYS]: 'data-range.last-90-days',
	[GroupDataRange.LAST_1_YEAR]: 'data-range.last-year',
};

const DATA_RANGE_BUTTON_LIST = [
	GroupDataRange.LAST_30_DAYS,
	GroupDataRange.LAST_90_DAYS,
	GroupDataRange.LAST_1_YEAR,
];

const ENHANCED_ONLY_RANGE_OPTIONS = [
	GroupDataRange.LAST_90_DAYS,
	GroupDataRange.LAST_1_YEAR,
];

export default defineComponent({
	components: { RadioList, PremiumTooltip, RadioListButton },
	props: {
		currentDataRange: {
			type: Number as PropType<GroupDataRange>,
			default: DEFAULT_RANGE,
		},
		isEnhancedDashboard: Boolean,
	},
	setup(props) {
		const dataRangeButtons: Ref<ButtonNavButton[]> = computed(() => DATA_RANGE_BUTTON_LIST.map((range) => ({
			key: range,
			label: DATA_RANGE_LABELS[range],
			to: {},
			disabled: !props.isEnhancedDashboard && ENHANCED_ONLY_RANGE_OPTIONS.includes(range),
		})));
		return {
			DATA_RANGE_LABELS,
			dataRangeButtons,
		};
	},
});
